import { getRandomString } from './socketUtils';

let singleton: TimeSync | undefined;

export class TimeSync {
  private _timeDiff = 0;

  constructor() {
    this.calculateTimeDiff();
  }

  private _rtt = 0;

  /**
   * network round trip time
   */
  get rtt() {
    return this._rtt;
  }

  /**
   * Get estimated time difference (in ms) between client and server
   * if timeDiff > 0, client time is ahead of server time
   * if timeDiff < 0, client time is behind server time
   * @returns time difference in milliseconds
   */
  get timeDiff() {
    return this._timeDiff;
  }

  static getInstance() {
    if (!singleton) {
      singleton = new TimeSync();
    }
    return singleton;
  }

  now(): Date {
    const _now = Date.now();
    return new Date(_now - this.timeDiff);
  }

  private calculateTimeDiff() {
    const startTime = performance.now();
    fetch(`https://realtime.dnse.com.vn/?no-cache=${Date.now()}${getRandomString(5)}`)
      .then(response => {
        const endTime = performance.now();
        const serverTime = response.headers.get('Date');
        const requestTime = endTime - startTime;
        this._rtt = requestTime;
        // [time diff] = [current time] - [server time] - [request time] / 2 (request time is round trip time)
        this._timeDiff = Date.now() - requestTime / 2 - (serverTime ? new Date(serverTime).getTime() : Date.now());
      })
      .catch(err => console.log('fetch failed: if this is reported on cors on local env, please ignore it', err));
  }
}
